import React from "react";
import { useSelector } from "react-redux";

import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Avatar from "@material-ui/core/Avatar";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

import LoadingSpinner from "../UI/LoadingSpinner/LoadingSpinner";

import Styles from "./TableInscription.module.css";

const useStyles = makeStyles((theme) => ({
	tableActions: {
		width: "100%",
	},
}));

const TableInscription = (props) => {
	const classes = useStyles();
	const history = useHistory();

	const isLoading = useSelector((state) => state.uiData.isLoading[7]);

	const iconButtonClickHandler = (item) => {
		if (item.trainingType === "Enumerable.TrainingType.Program") {
			history.push("/formacao/courses/details/" + item.id);
		}
		if (item.trainingType === "Enumerable.TrainingType.Class") {
			history.push("/formacao/courses/actions/details/" + item.id);
		}
	};

	return (
		<div className={Styles["TableInscription"]}>
			<Table className={classes.table} aria-label="Actions table">
				<TableHead>
					<TableRow className={Styles["MuiTableRow-head"]}>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Nome</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Tipo</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Data inicio</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Data fim</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Metodologia</div>
						</TableCell>
						{/* <TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Estado</div>
						</TableCell> */}
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}></div>
						</TableCell>
					</TableRow>
				</TableHead>
				{!isLoading && props.TableInscriptionData.length > 0 && (
					<TableBody>
						{props.TableInscriptionData.map((row) => (
							<TableRow
								key={row.id}
								className={Styles["MuiTableBody-root"]}
							>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
									component="th"
									scope="row"
								>
									<div className={Styles["subtitle"]}>
										{row.name}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.trainingType ===
										"Enumerable.TrainingType.Program"
											? "Curso"
											: "Módulo"}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.startDateStr}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.endDateStr}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.modality.name}
									</div>
								</TableCell>
								{/* <TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									<div
										className={`${Styles["state"]} ${Styles["green"]}`}
									></div>
								</div>
							</TableCell> */}
								<TableCell
									className={`${Styles["MuiTableCell-root"]} ${Styles["MuiTableCell-icon"]}`}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										<IconButton
											aria-label="forward"
											onClick={iconButtonClickHandler.bind(
												null,
												row
											)}
										>
											<Icon>arrow_forward_ios</Icon>
										</IconButton>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				)}
			</Table>
			{isLoading && (
				<div style={{ textAlign: "center" }}>
					<LoadingSpinner />
				</div>
			)}
			{props.TableInscriptionData.length == 0 && (
				<div className={Styles["no-record-found"]}>
					Não foi encontrado nenhum registo
				</div>
			)}
		</div>
	);
};

export default TableInscription;
